/**
 *  Bir projenin ana request atacağı servis base_url'i
 * @param {string} BASE_URL - API servisi BASE URL'i
 */

// export const BASE_URL = "http://192.168.1.98:7121/api";

//export const BASE_URL_IMAGE = "http://192.168.1.98:7121/";

// export const BASE_URL = "https://j9tvsn90-7121.euw.devtunnels.ms/api";

export const BASE_URL = "https://api.tmsgrup.com/api";

export const BASE_URL_IMAGE = "https://api.tmsgrup.com/";

export const SIGNALR_BASE_URL = "https://api.tmsgrup.com";
